const bimg = (id, crop = "entropy", w = 1400) =>
  `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop&crop=${crop}`;

const A = bimg("photo-1519824145371-296894a0daa9", "edges");
const B = bimg("photo-1519823551278-64ac92734fb1", "faces");
const C = bimg("photo-1745327883508-b6cd32e5dde5", "bottom");
const D = bimg("photo-1596178060671-7a80dc8059ea", "edges");

export const SPORTS_POSTS = [
  {
    slug: "therapeutic-massage-vs-relaxation-massage",
    title: "Therapeutic Massage vs. Relaxation Massage: The Real Difference",
    keyword: "therapeutic massage vs relaxation massage",
    category: "Therapeutic & Sports Massage",
    read: "4 min read",
    img: A,
    excerpt:
      "One changes tissue, the other changes state. What separates a therapeutic session from a relaxation one — and why the best sessions do both.",
    body: [
      {
        p: [
          "Relaxation massage changes your state: slower heart rate, deeper breath, a nervous system that finally downshifts. Therapeutic massage changes tissue: releasing adhesions, lengthening shortened muscles, addressing the specific place that hurts. Both are legitimate — they simply answer different questions.",
        ],
      },
      {
        h: "How to tell which you need",
        p: [
          "Ask what you want to be different afterwards. “I want to feel human again” points to relaxation. “I want my shoulder to move again” points to therapeutic work. If the answer is both — and it usually is — a customized session blends them deliberately.",
        ],
      },
      {
        h: "The overlap nobody mentions",
        p: [
          "Therapeutic work done well is deeply relaxing, and a relaxed body accepts deeper change. The two are not rivals; they are gears of the same machine. At Royal Essence, the balance between them is set per session, per person.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "sports-massage-vs-deep-tissue-massage",
    title: "Sports Massage vs. Deep Tissue Massage: What to Choose",
    keyword: "sports massage vs deep tissue massage",
    category: "Therapeutic & Sports Massage",
    read: "4 min read",
    img: B,
    excerpt:
      "They share techniques but serve different masters: one serves the calendar of training, the other serves the tissue. Which one your week needs.",
    body: [
      {
        p: [
          "Sports massage and deep tissue massage use overlapping tools — slow strokes, sustained pressure, stretching — but they are organized around different goals. Deep tissue answers “where does it hurt and why”. Sports massage answers “what is your training doing to you this week”.",
        ],
      },
      {
        h: "Choose sports massage when…",
        p: [
          "You train regularly and want the session timed to it: lighter, flushing work before an event; deeper, restorative work in the days after; maintenance work during heavy blocks. The session is built around your sport's specific demands — a runner's hips and calves, a lifter's shoulders and grip.",
        ],
      },
      {
        h: "Choose deep tissue when…",
        p: [
          "The issue is a place, not a schedule: the knot that will not leave, the hip that lost its range. Many active people alternate — sports massage in training weeks, deep tissue when something specific complains.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "sports-massage-before-or-after-workout",
    title: "Sports Massage: Before or After a Workout?",
    keyword: "sports massage before or after workout",
    category: "Therapeutic & Sports Massage",
    read: "4 min read",
    img: C,
    excerpt:
      "Timing changes everything. What pre-workout and post-workout massage each do — and the recovery window that matters most.",
    body: [
      {
        p: [
          "Both timings work — they just do different jobs. Pre-workout massage is a primer; post-workout massage is a repair crew.",
        ],
      },
      {
        h: "Before: prime, don't relax",
        p: [
          "Pre-training work is brisk and brief: flushing strokes, light compression, mobility. The goal is warm, responsive tissue — not deep relaxation, which temporarily reduces power output. Within 24 hours before hard training, keep it light; save the deep work for after.",
        ],
      },
      {
        h: "After: the repair window",
        p: [
          "Post-workout massage — ideally within 24 to 72 hours — moves metabolic byproducts, eases next-day soreness and restores range while the tissue is still adapting. This is where deep tissue and sports techniques shine.",
          "The simple rule: light before, deep after, and never deep within a day of maximal effort.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "massage-before-competition",
    title: "How Many Days Before a Competition Should You Get a Massage?",
    keyword: "massage before competition",
    category: "Therapeutic & Sports Massage",
    read: "3 min read",
    img: D,
    excerpt:
      "Too close and you race on relaxed, heavy legs; too far and the benefit fades. The pre-event timing that works.",
    body: [
      {
        p: [
          "Pre-competition massage is about arriving loose, fresh and responsive — and timing is the whole trick.",
        ],
      },
      {
        h: "The timing map",
        p: [
          "Deep tissue work: 3 to 5 days out. It releases the accumulated tightness while leaving time for post-session soreness to fade completely. Lighter flushing or sports massage: 1 to 2 days before — a primer, not a project. On race day itself: only what your routine has already proven; event day is not the day for experiments.",
        ],
      },
      {
        h: "The golden rule of taper week",
        p: [
          "Nothing new. Not a new technique, not a new therapist, not heroic pressure. Bodies perform on the familiar. If massage is part of your season plan, make it routine long before it matters.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "post-workout-massage-benefits",
    title: "Massage After a Workout: Does It Actually Help Recovery?",
    keyword: "post workout massage benefits",
    category: "Therapeutic & Sports Massage",
    read: "4 min read",
    img: A,
    excerpt:
      "What post-training massage reliably does — less soreness, faster range return — and the honest limits of what it cannot do.",
    body: [
      {
        p: [
          "The appeal is obvious: train hard, then have someone undo the damage. The research picture is genuinely favourable, with honest boundaries.",
        ],
      },
      {
        h: "What it reliably does",
        p: [
          "Post-workout massage consistently reduces delayed-onset muscle soreness — the day-two ache — and restores range of motion faster than rest alone. It also lowers perceived fatigue, which matters more than it sounds: athletes who feel recovered train better.",
        ],
      },
      {
        h: "What it does not do",
        p: [
          "It does not “flush lactic acid” (that clears on its own within an hour), and it does not replace sleep, food and rest days. Think of massage as a multiplier on good recovery habits, not a substitute for them.",
          "Best timing: within 24 to 72 hours after hard training, with pressure scaled to how worked the tissue is.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "massage-for-sore-legs-after-running",
    title: "Massage for Sore, Heavy Legs After Running",
    keyword: "massage for sore legs after running",
    category: "Therapeutic & Sports Massage",
    read: "4 min read",
    img: B,
    excerpt:
      "Calves like concrete, quads like stone. How a post-run leg session works and when to book it after a hard effort.",
    body: [
      {
        p: [
          "Every runner knows the morning-after legs: calves dense as rope, quads complaining on stairs. Running asks the legs to absorb thousands of impacts; soreness is the invoice.",
        ],
      },
      {
        h: "What the session does",
        p: [
          "A post-run leg session works the full chain — calves and the soleus underneath them, hamstrings, quads, hip flexors and glutes — with long flushing strokes toward the heart and deeper specific work where the density lives. The feet often get a say too; they took the same beating.",
        ],
      },
      {
        h: "Timing after a hard run",
        p: [
          "For a routine hard workout, within a day or two is ideal. After a race or your longest run of the season, give the tissue 48 hours to settle before deep work, then book. Gentle walking and hydration bridge the gap.",
        ],
      },
    ],
    note:
      "Sharp, localized pain — especially in the shin, Achilles or under the foot — is not soreness; get it assessed before massage.",
  },
  {
    slug: "sports-massage-for-runners",
    title: "Sports Massage for Runners",
    keyword: "sports massage for runners",
    category: "Therapeutic & Sports Massage",
    read: "4 min read",
    img: C,
    excerpt:
      "Running is repetitive by design — thousands of identical steps. Where that repetition settles in the body and how a runner's session is built.",
    body: [
      {
        p: [
          "Running is beautifully simple and brutally repetitive: the same motion, thousands of times, at several times body weight per step. The pattern it writes is predictable — calves and Achilles, hamstrings, hip flexors, IT band, and the feet that absorb it all.",
        ],
      },
      {
        h: "A runner's session",
        p: [
          "Work follows the chain the mileage builds: deep but patient release of the calves and soleus, hamstring and quad work, hip flexor opening (runners sit too), and glute balance. During high-mileage blocks the pressure stays moderate; in the off-season or recovery weeks, deeper corrective work happens.",
        ],
      },
      {
        h: "The rhythm that works",
        p: [
          "Recreational runners do well with a session every 3 to 4 weeks; those building toward a race often go every two weeks through peak training. The massage should track the plan, not just the pain.",
        ],
      },
    ],
    note:
      "Pain that changes your running form, or that worsens run over run, deserves assessment before massage — early attention is what keeps small niggles small.",
  },
  {
    slug: "sports-massage-for-cyclists",
    title: "Sports Massage for Cyclists: Lower Back, Hips and Legs",
    keyword: "sports massage for cyclists",
    category: "Therapeutic & Sports Massage",
    read: "4 min read",
    img: D,
    excerpt:
      "Hours folded over handlebars write a specific signature: short hip flexors, a rounded back, dense quads. How massage reads it.",
    body: [
      {
        p: [
          "The cycling position is a long, still fold: hips flexed, spine rounded, neck extended to see the road. None of it is wrong — until it is held for three hours at a time, week after week. The result is the classic cyclist's pattern.",
        ],
      },
      {
        h: "The cyclist's pattern",
        p: [
          "Short, dense hip flexors that tilt the pelvis and strain the lower back. Quads and calves worked hard but rarely lengthened. A thoracic spine held in flexion, and a neck craned upward out of it. A cyclist's session opens the hips, decompresses the lower back, and restores the upper spine and neck — in that order of importance.",
        ],
      },
      {
        h: "Off the table",
        p: [
          "Two minutes of hip-flexor and chest opening after every ride protects the position better than any monthly repair. The bike fit matters too — no massage schedule can outwork a saddle in the wrong place.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "sports-massage-for-weightlifters",
    title: "Sports Massage for Weightlifters and Gym-Goers",
    keyword: "sports massage for weightlifters",
    category: "Therapeutic & Sports Massage",
    read: "4 min read",
    img: A,
    excerpt:
      "Lifting makes muscles strong and short. Massage keeps the second part from limiting the first — where lifters most often need the work.",
    body: [
      {
        p: [
          "Strength training deliberately shortens tissue under load. Managed well, that is how muscle is built; unmanaged, range quietly shrinks — the shoulders that will not lock out overhead, the hips that no longer reach depth, the lats that pull the whole shoulder girdle down.",
        ],
      },
      {
        h: "Where lifters need it most",
        p: [
          "Pecs and lats for overhead position; hip flexors and glutes for the squat; forearms and grip for anyone pulling heavy; the thoracic spine for everything. A lifter's session is less about soreness and more about positions — restoring the range your program asks for.",
        ],
      },
      {
        h: "Timing around training",
        p: [
          "Deep work fits best on rest days or 48 hours before heavy sessions in the same muscle group. Keep lighter, flushing work for the day before lifting. Consistency through a training block beats one heroic session after something hurts.",
        ],
      },
    ],
    note: null,
  },
  {
    slug: "massage-for-tight-calves",
    title: "Massage for Tight Calves",
    keyword: "massage for tight calves",
    category: "Therapeutic & Sports Massage",
    read: "3 min read",
    img: B,
    excerpt:
      "Tight calves quietly limit your ankles, strain your feet and change how you move. A small muscle group with an outsized say.",
    body: [
      {
        p: [
          "The calf — gastrocnemius on top, soleus beneath — shortens with sitting, tightens with running and walking, and stiffens with heels of any height. Because it controls ankle motion, tight calves echo upward into the knees and downward into the feet and Achilles.",
        ],
      },
      {
        h: "What the work involves",
        p: [
          "Calf work is slow and specific: warming strokes, then sustained pressure along the length of both muscles, attention to the trigger points that hide mid-belly, and gentle ankle movement to lengthen as pressure releases. Tender, yes — but the kind of tender that walks out lighter.",
        ],
      },
      {
        h: "A daily ninety seconds",
        p: [
          "A wall calf stretch, ninety seconds each side with the knee straight and then bent, preserves ankle range between sessions better than any gadget.",
        ],
      },
    ],
    note:
      "A calf that is swollen, warm, red and tender — especially on one side — can indicate a blood clot. That is urgent medical territory, not massage. When in doubt, get it checked.",
  },
  {
    slug: "massage-for-tight-hamstrings",
    title: "Massage for Tight Hamstrings",
    keyword: "massage for tight hamstrings",
    category: "Therapeutic & Sports Massage",
    read: "3 min read",
    img: C,
    excerpt:
      "Hamstrings that never loosen are usually protecting something — often the pelvis and lower back. How massage approaches them.",
    body: [
      {
        p: [
          "Chronically tight hamstrings are often a symptom, not a problem. When the pelvis tips forward — desk posture's favourite trick — the hamstrings are held on stretch and respond by guarding. Stretching them harder can, surprisingly, make things worse.",
        ],
      },
      {
        h: "The session's logic",
        p: [
          "Work starts with what is pulling: the hip flexors and lower back. Then the hamstrings themselves — slow deep strokes along the length of the group, specific work at the sit-bone attachment where runners and lifters get dense, finished with gentle lengthening. Range tends to return quickly once the front of the hip stops arguing.",
        ],
      },
    ],
    note:
      "Sudden hamstring pain with bruising after a sprint or lift is a strain — acute injuries need assessment before massage.",
  },
  {
    slug: "massage-for-plantar-fasciitis",
    title: "Massage for Plantar Fasciitis",
    keyword: "massage for plantar fasciitis",
    category: "Therapeutic & Sports Massage",
    read: "4 min read",
    img: D,
    excerpt:
      "That stabbing first step in the morning. Massage approaches plantar fasciitis from the calf down — and what realistic relief looks like.",
    body: [
      {
        p: [
          "Plantar fasciitis announces itself with a trademark: a stabbing heel pain with the first steps of the morning, easing as the foot warms up, returning after long standing. The irritated band under the foot is the loud part — but rarely the whole story.",
        ],
      },
      {
        h: "Why the calf is in the room",
        p: [
          "Tight calves and a stiff Achilles increase the load on the plantar fascia with every step. Effective sessions therefore work the entire lower leg: releasing the calf muscles, mobilizing the ankle, and only then specific, careful work on the foot itself and the fascia.",
        ],
      },
      {
        h: "Realistic expectations",
        p: [
          "Massage may help reduce pain and improve foot mechanics — especially combined with calf stretching, supportive footwear and load management. Plantar fasciitis typically resolves over weeks to months; massage makes that journey considerably more comfortable.",
        ],
      },
    ],
    note:
      "Heel pain that persists despite conservative care, or follows an injury, should be assessed — stress fractures and nerve issues can mimic plantar fasciitis.",
  },
  {
    slug: "massage-for-tennis-elbow",
    title: "Can Massage Help Tennis Elbow?",
    keyword: "massage for tennis elbow",
    category: "Therapeutic & Sports Massage",
    read: "4 min read",
    img: A,
    excerpt:
      "Despite the name, most tennis elbow belongs to typists, lifters and tradespeople. Where massage helps — and the patience it requires.",
    body: [
      {
        p: [
          "Tennis elbow — lateral epicondylitis — is irritation of the tendons that anchor the forearm's extensor muscles at the outer elbow. It belongs far more often to mouse-heavy desks, gripping trades and gym programs than to tennis courts.",
        ],
      },
      {
        h: "Where massage fits",
        p: [
          "Work focuses on the forearm muscles themselves — releasing the chronic tension that keeps loading the tendon — plus the wrist, hand, and often the shoulder that sits upstream in the same chain. Direct tendon work is gentle and brief; the muscle release around it is the main event.",
        ],
      },
      {
        h: "The honest timeline",
        p: [
          "Tendons remodel slowly. Massage may help reduce pain and improve grip comfort, but expect weeks, not sessions. The provocation — the gripping, lifting or typing pattern — must also be modified, or each session is undone by Wednesday.",
        ],
      },
    ],
    note:
      "Elbow pain with swelling, locking, or after trauma needs medical assessment. Persistent cases benefit from a combined plan with physiotherapy.",
  },
  {
    slug: "massage-for-repetitive-strain-injury",
    title: "Massage for Repetitive Strain Injuries (RSI)",
    keyword: "massage for repetitive strain injury",
    category: "Therapeutic & Sports Massage",
    read: "4 min read",
    img: B,
    excerpt:
      "A thousand small repetitions add up: wrists, forearms, thumbs, necks. How massage fits into RSI recovery — and what must change with it.",
    body: [
      {
        p: [
          "RSI is not one injury but a family: tendons and muscles worn down by the same motion repeated thousands of times — typing, mousing, assembly work, instruments. The pain typically builds gradually, which is exactly why it is often addressed late.",
        ],
      },
      {
        h: "What massage contributes",
        p: [
          "Sessions release the chronically overloaded muscles — forearm flexors and extensors for wrist RSI, the neck and shoulder girdle when the whole arm chain is involved — and restore circulation to tissue that repetition starves. Many clients feel meaningful relief within the first few sessions.",
        ],
      },
      {
        h: "The non-negotiable partner",
        p: [
          "No bodywork outruns the repetition that caused the problem. Ergonomic changes, micro-breaks and workload adjustment are the treatment; massage is what makes the tissue able to respond to them. Early RSI responds well; long-ignored RSI needs a broader medical plan.",
        ],
      },
    ],
    note:
      "Persistent numbness or tingling in the hand (especially at night) can indicate carpal tunnel syndrome — that needs medical evaluation before or alongside massage.",
  },
  {
    slug: "massage-after-sports-injury",
    title: "When Can You Return to Massage After a Sports Injury?",
    keyword: "massage after sports injury",
    category: "Therapeutic & Sports Massage",
    read: "4 min read",
    img: C,
    excerpt:
      "Too early and massage irritates healing tissue; well-timed and it shapes how that tissue heals. The phases of injury and where massage fits each.",
    body: [
      {
        p: [
          "After a strain, sprain or pull, the question is not whether massage helps — it is when. Injured tissue moves through predictable phases, and massage has a different job in each.",
        ],
      },
      {
        h: "The phases",
        p: [
          "Acute (first 48–72 hours): rest — massage waits. Sub-acute (the following one to three weeks): gentle work around, not on, the injury — releasing the guarding that splints the area, keeping neighbouring joints moving. Remodelling (weeks three and beyond): progressively deeper, specific work helps the new tissue lay down along lines of stress — strong and aligned, rather than a stiff patch of scar.",
        ],
      },
      {
        h: "The safe sequence",
        p: [
          "Get the injury assessed first — diagnosis determines the timeline more than soreness does. Then bring the timeline to your therapist; a good one will adapt pressure session by session as healing progresses. Massage at the right phase shortens the road; massage at the wrong phase lengthens it.",
        ],
      },
    ],
    note:
      "Suspected fractures, significant swelling, or inability to bear weight need immediate medical assessment — before any massage.",
  },
];
